import { SwipeableDrawer, Button } from "@mui/material";
import { useTranslations } from "use-intl";
import dayjs from "dayjs";
import { usePaymentContext } from "@/app/lib/context/PaymentContext";
import { formatCurrency } from "@/app/lib/utils/currency";
import { useLocaleInfo } from "@/app/lib/hooks/useLocaleInfo";

interface InstallmentBreakdownDrawerProps {
  totalPrice: number;
  open: boolean;
  onClose: () => void;
}

const InstallmentBreakdownDrawer = ({
  totalPrice,
  open,
  onClose,
}: InstallmentBreakdownDrawerProps) => {
  const t = useTranslations();
  const { locale } = useLocaleInfo();
  const { selectedInstallments } = usePaymentContext();

  const nextPaymentMonth = dayjs()
    .add(1, "month")
    .locale(locale)
    .format("MMMM");

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableRestoreFocus
    >
      <div className="pt-2">
        <div className="mb-6 text-center text-base font-medium">
          {t("instalmentBreakdown.title")}
        </div>
        <div className="mb-6 flex flex-col gap-3 text-sm">
          <div className="flex justify-between">
            <span>{t("instalmentBreakdown.numberOfInstalments")}</span>
            <span className="font-bold">
              {t("instalmentBreakdown.months", { count: selectedInstallments })}
            </span>
          </div>
          <div className="flex justify-between">
            <span>{t("instalmentBreakdown.nextPayment")}</span>
            <span className="font-bold">{nextPaymentMonth}</span>
          </div>
          <div className="flex justify-between">
            <span>{t("instalmentBreakdown.monthlyPayment")}</span>
            <span className="font-bold">
              {formatCurrency(totalPrice / selectedInstallments)}
            </span>
          </div>
          <div className="flex justify-between">
            <span>{t("total")}</span>
            <span className="font-bold">{formatCurrency(totalPrice)}</span>
          </div>
        </div>

        <Button fullWidth variant="contained" onClick={onClose}>
          {t("common.close")}
        </Button>
      </div>
    </SwipeableDrawer>
  );
};

export default InstallmentBreakdownDrawer;
